import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BannerModule } from '@app/components/banner/banner.module';
import { CarouselModule } from '@app/components/carousel/carousel.module';
import { ContainerScrollModule } from '@app/components/container-scroll/container-scroll.module';
import { HeaderModule } from '@app/components/header/header.module';
import { IconsModule } from '@app/components/icons/icons.module';
import { ListItemsModule } from '@app/components/list-items/list-items.module';
import { SendRateAndCommentModule } from '@app/components/send-rate-and-comment/send-rate-and-comment.module';
import { SharedModule } from '@app/shared/shared.module';

import { CLPRoutingModule } from './clp-routing.module';
import { CLPComponent } from './clp/clp.component';
import { PlpAllListComponent } from './plp/plp-all-list/plp-all-list.component';
import { PlpListItemComponent } from './plp/plp-list/plp-list-item/plp-list-item.component';
import { PlpListComponent } from './plp/plp-list/plp-list.component';
import { PLPComponent } from './plp/plp.component';


@NgModule({
  declarations: [
    PLPComponent,
    CLPComponent,
    PlpListComponent,
    PlpListItemComponent,
    PlpAllListComponent,

  ],
  imports: [
    CommonModule,
    CLPRoutingModule,
    SharedModule,
    ListItemsModule,
    CarouselModule,
    BannerModule,
    HeaderModule,
    ContainerScrollModule,
    SendRateAndCommentModule,
    IconsModule
  ]
})
export class CLPModule { }
